import httpClient from 'shared/lib/httpClient';
import { parseUserOptions } from '../schemas/MasterDataSchema';

export const getUserOptions = async (params, signal) => {
  const response = await httpClient.get('/options/company-users', {
    params,
    signal,
  });
  return parseUserOptions(response?.data);
};
